/**
 * 조회 아이디 신청
 */
import React, { Component } from 'react';
import { Modal, ListGroup, InputGroup, Navbar, Container, Form, Button, Row, Col } from 'react-bootstrap';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, AlertModal, openAlert } from '../common/common';
import loader from '../imgs/ajax-loader.gif';
import logoBi from '../logo-bi.png';
import policeBi from '../police.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowCircleLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

let isRunning = false;
let isLogging = false;
let that = this;

class JoinStdtCmp extends Component {
  constructor(props) {
    super(props);

    const userGu = props.match.params.userGu;

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      userGu: userGu,
      validated: false,

      ORGNZT_ID: '',
      ORGNZT_NM: '',

      USE_CHK: false,
      EMPLYR_ID_CHK: false,

      // 학교검색 modal
      schoolAlertShow: false,
      schoolList: [],
      hakgwaList: [],
      searchKeyword: '',

      partKey: '',

      // 로그인은 되었으나 학생정보가 변경된 경우 체크
      WILL_UPDATE: false,
    }
  }

  componentDidMount = () => {
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });

    if (!isRunning && !isLogging) {
      isLogging = true;
      let that = this;

      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        isRunning = false;
        isLogging = false;
        if (data !== null && data.userSe === 'STDT') {
          that.setState({ WILL_UPDATE: true, ORGNZT_ID: data.ORGNZT_ID, partKey: data.partKey });
          that.fn_searchHakgwa(data.ORGNZT_ID)
        }
      });
    }
  }

  // bootstrap Alert
  // 닫기 버튼 기본 활성화
  alertClose = (key) => {
    this.setState({
      [key]: false,
      // 검색 조건 초기화
      searchKeyword: ''
    });
  }

  // change form value
  handleInputChange = (target) => {
    this.setState({
      [target.name]: target.value
    });
  }

  // 학교 조회
  fn_searchSchool = () => {
    that = this;

    if (!isRunning) {
      isRunning = true;
      udfInlineLoading();

      $.ajax({
        url: url + '/slp/selectSchoolListPUP.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          searchKeyword: that.state.searchKeyword,
        },
        success: function (data) {
          udfNoneLoading();
          if (data.success) {
            let schoolList = [];

            if (data.resultList !== undefined && data.resultList !== '') {
              $.each(data.resultList, function (i, val) {
                schoolList.push({
                  ORGNZT_ID: val.ORGNZT_ID,
                  ORGNZT_NM: val.ORGNZT_NM,
                  ADDR: val.ADDR,
                  TEL: val.TEL,
                });
              });
            }

            if (data.resultList !== null && data.resultList.length === 0)
              $("#searchKeyword").next().next().show();
            else
              $("#searchKeyword").next().next().hide();

            isRunning = false;

            that.setState({
              schoolList: schoolList,
              schoolAlertShow: true
            });
          }
        },
        error: function () {
          isRunning = false;
          udfNoneLoading();
        }
      });
    }
  }

  // 학교 선택
  fn_select_school = (data) => {
    this.setState({
      schoolAlertShow: false,
      ORGNZT_ID: data.ORGNZT_ID,
      ORGNZT_NM: data.ORGNZT_NM,
      USE_CHK: false,
      EMPLYR_ID_CHK: false,
    });
    this.fn_searchHakgwa(data.ORGNZT_ID);
  }

  // 학과 조회
  fn_searchHakgwa = (v_ORGNZT_ID) => {
    that = this;

    if (!isRunning) {
      isRunning = true;
      udfInlineLoading();

      $.ajax({
        url: url + '/slp/selectHakgwaList.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          SF_ORGNZT_ID: v_ORGNZT_ID,
        },
        success: function (data) {
          udfNoneLoading();
          if (data.result) {
            let hakgwaList = [];

            if (data.lists !== undefined && data.lists !== '') {
              $.each(data.lists, function (i, val) {
                hakgwaList.push({
                  HAKGWA: val.HAKGWA,
                });
              });
            }

            isRunning = false;

            that.setState({
              hakgwaList: hakgwaList,
            });
          }
        },
        error: function () {
          isRunning = false;
          udfNoneLoading();
        }
      });
    }
  }

  // 학생 유효 검사
  fn_selectStdtIsExists = () => {
    that = this;
    let { WILL_UPDATE } = that.state;

    if ($("#ORGNZT_NM").val() === "" && !WILL_UPDATE) {
      $("#ORGNZT_NM").next().next().show();
      return;
    } else
      $("#ORGNZT_NM").next().next().hide();

    if ($("#GRADE").val() === "") {
      $("#GRADE").next().show();
      $("#GRADE").focus();
      return;
    } else
      $("#GRADE").next().hide();

    if ($("#BAN").val() === "") {
      $("#BAN").next().show();
      $("#BAN").focus();
      return;
    } else
      $("#BAN").next().hide();

    if ($("#BUN").val() === "") {
      $("#BUN").next().show();
      $("#BUN").focus();
      return;
    } else
      $("#BUN").next().hide();

    if ($("#STD_NM").val() === "") {
      $("#STD_NM").next().next().show();
      $("#STD_NM").focus();
      return;
    } else
      $("#STD_NM").next().next().hide();

    if (!isRunning) {
      isRunning = true;
      udfInlineLoading();

      if (!WILL_UPDATE)
        $.ajax({
          url: url + '/slp/selectStdtIsExists.do',
          type: 'GET',
          dataType: 'jsonp',
          data: {
            isMobile: 'Y',
            ORGNZT_ID: that.state.ORGNZT_ID,
            HAKGWA: $("#HAKGWA").val() === null ? "" : $("#HAKGWA").val(),
            GRADE: $("#GRADE").val(),
            BAN: $("#BAN").val(),
            BUN: $("#BUN").val(),
            STD_NM: $("#STD_NM").val(),
          },
          success: function (data) {
            udfNoneLoading();
            if (data.result === "NS") {
              openAlert(that, "학생정보를 확인할 수 없습니다.\n\n학교로 문의해 주세요.");
            } else if (data.result === "NI") {
              openAlert(that, "이미 신청 완료된 학생정보입니다.");
            } else if (data.result === "ERR") {
              openAlert(that, "오류가 발생했습니다.");
            } else {
              openAlert(that, "학생정보가 확인되었습니다.");
              that.setState({
                USE_CHK: true,
                STD_CD: data.result,
                partKey: data.partKey,
              });
            }

            isRunning = false;

          },
          error: function () {
            isRunning = false;
            udfNoneLoading();
          }
        });
      else
        $.ajax({
          url: url + '/slp/stdt/updateStdtIsExists.do',
          type: 'GET',
          dataType: 'jsonp',
          data: {
            isMobile: 'Y',
            ORGNZT_ID: that.state.ORGNZT_ID,
            HAKGWA: $("#HAKGWA").val() === null ? "" : $("#HAKGWA").val(),
            GRADE: $("#GRADE").val(),
            BAN: $("#BAN").val(),
            BUN: $("#BUN").val(),
            STD_NM: $("#STD_NM").val(),
            'egovframework.double.submit.preventer.parameter.name': that.state.partKey,
          },
          success: function (data) {
            that.setState({ partKey: data.partKey });
            udfNoneLoading();
            if (data.result === "NI") {
              openAlert(that, "이미 신청 완료된 학생정보입니다.");
            } else if (data.result === 1) {
              openAlert(that, "학생정보가 확인되었습니다.");
              that.props.history.push('/stdt/ruleList');
            } else {
              openAlert(that, "학생정보를 확인할 수 없습니다.\n\n학교로 문의해 주세요.");
            }

            isRunning = false;

          },
          error: function () {
            isRunning = false;
            udfNoneLoading();
          }
        });
    }
  }

  /**
   * @desc 입력 검사 문자, 숫자, 마침표(.), 빼기표(-), 밑줄(_)
   */
  fn_userIdCheck(inputId) {
    that = this;
    var str = $("#" + inputId).val();

    if (str.length < 4) {
      openAlert(that, "아이디는 문자, 숫자, 마침표(.), 빼기표(-), 밑줄(_)의 조합으로 4자리 이상 입력해주세요.");
      return false;
    }

    if (str.length > 0) {
      // 입력문자 체크 : 영문 소문자, 숫자, 마침표(.), 빼기표(-), 밑줄(_)
      for (var i = 0; i < str.length; i++) {
        var ch = str.charAt(i);
        if ((ch >= '0' && ch <= '9') || (ch >= 'a' && ch <= 'z')
          || ch === '.' || ch === '-' || ch === '_') {
          continue;
        } else {
          openAlert(that, "아이디는 문자, 숫자, 마침표(.), 빼기표(-), 밑줄(_)만 입력이 가능합니다.");
          // $("#" + inputId).val("");
          $("#" + inputId).focus();
          return false;
        }
      }

    }
    return true;
  }

  /**
   * @desc 입력문자 체크 : 영문 대/소문자, 숫자, 특수문자
   * @arguments ( object )
   */
  fn_userPwdCheck(inputId) {
    that = this;
    var str = $("#" + inputId).val();

    if (str.length < 6) {
      openAlert(that, "비밀번호는 문자, 숫자, 특수문자의 조합으로 6자리 이상 입력해 주세요.");
      return false;
    }

    if (!str
      .match(/^[a-zA-Z0-9]/)) {
      openAlert(that, "비밀번호는 영문자 또는 숫자로 시작하여 입력해 주세요.");
      return false;
    }

    if (!str
      .match(/([a-zA-Z0-9].*[!,@,#,$,%,^,&,*,?,_,~])|([!,@,#,$,%,^,&,*,?,_,~].*[a-zA-Z0-9])/)) {
      openAlert(that, "비밀번호는 문자, 숫자, 특수문자의 조합으로 6자리 이상 입력해 주세요.");
      return false;
    }

    var SamePass_0 = 0; // 동일문자 카운트
    var SamePass_1 = 0; // 연속성(+) 카운드
    var SamePass_2 = 0; // 연속성(-) 카운드

    var chr_pass_0;
    var chr_pass_1;

    for (var i = 0; i < str.length; i++) {
      chr_pass_0 = str.charAt(i);
      chr_pass_1 = str.charAt(i + 1);

      // 동일문자 카운트
      if (chr_pass_0 === chr_pass_1) {
        SamePass_0 = SamePass_0 + 1
      }

      // 연속성(+) 카운드
      if (chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) === 1) {
        SamePass_1 = SamePass_1 + 1
      } else
        SamePass_1 = SamePass_1 < 2 ? 0 : SamePass_1;

      // 연속성(-) 카운드
      if (chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) === -1) {
        SamePass_2 = SamePass_2 + 1
      } else
        SamePass_2 = SamePass_2 < 2 ? 0 : SamePass_2;
    }

    if (SamePass_0 >= 2) {
      openAlert(that, "비밀번호는 동일문자를 3번 이상(111, aaa, !!! 등) 사용할 수 없습니다.");
      return false;
    }

    if (SamePass_1 >= 2 || SamePass_2 >= 2) {
      openAlert(that, "비밀번호는 연속된 문자열(123 또는 321, abc, cba 등)을 3자 이상 사용할 수 없습니다.");
      return false;
    }
    return true;
  }

  /**
   * ID 중복검사
   */
  fn_selectIdIsExists = () => {
    that = this;
    if ($("#EMPLYR_ID").val() === "") {
      $("#EMPLYR_ID").next().next().show();
      $("#EMPLYR_ID").focus();
      return;
    } else
      $("#EMPLYR_ID").next().next().hide();

    if (!this.fn_userIdCheck("EMPLYR_ID")) return;

    $.ajax({
      url: url + '/slp/selectIdIsExists.do',
      type: 'GET',
      dataType: 'jsonp',
      data: {
        isMobile: 'Y',
        EMPLYR_ID: $("#EMPLYR_ID").val(),
      },
      success: function (data) {
        if (data.result === "ERR") {
          openAlert(that, "오류가 발생했습니다.");
        } else if (data.result) {
          openAlert(that, "사용할 수 없는 아이디입니다.");
        } else {
          openAlert(that, "사용 가능한 아이디입니다.");
          that.setState({
            EMPLYR_ID_CHK: true,
          });
        }
      },
      error: function () {

      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const that = this;

    if (form.checkValidity()) {
      if (!that.state.USE_CHK) {
        openAlert(that, "학생 유효검사를 먼저 해 주세요.");
        return;
      }

      if (!that.state.EMPLYR_ID_CHK) {
        openAlert(that, "아이디 중복검사를 먼저 해 주세요.");
        return;
      }
      // 비밀번호 유효성 검사
      if (!that.fn_userPwdCheck("PASSWORD")) {
        $("#PASSWORD").focus();
        return;
      }

      if ($("#PASSWORD").val() !== $("#PASSWORD2").val()) {
        openAlert(that, "비밀번호 확인이 틀립니다.");
        $("#PASSWORD").focus();
        return;
      }

      udfInlineLoading();

      $.ajax({
        url: url + '/slp/insertStdtInfo.do',
        type: 'GET',
        dataType: "jsonp",
        data: {
          isMobile: 'Y',
          partKey: that.state.partKey,
          ORGNZT_ID: that.state.ORGNZT_ID,
          STD_CD: that.state.STD_CD,
          'egovframework.double.submit.preventer.parameter.name': that.state.partKey,
          EMPLYR_ID: $("#EMPLYR_ID").val(),
          PASSWORD: $("#PASSWORD").val(),
        },
        success: function (data) {
          udfNoneLoading();
          if (data.result === "ERR") {
            openAlert(that, "오류가 발생했습니다.");
          } else if (data.result) {
            let msg = "정상적으로 신청되었습니다.";
            if (data.lkupIdAtYn === "N") {
              msg = msg + "\n\n" + data.ORGNZT_NM + " 운영 방침에 따라 사용 승인 후에 로그인이 가능합니다."
                + "\n승인 처리는 학교 사정에 따라서 늦어질수도 있으며 관련 문의는 학교 담임교사/생활지도담당교사에게 문의하여 주시기 바랍니다.";
            }
            openAlert(that, msg, () => { that.props.history.push('/login/S'); });
          }
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          openAlert(that, "오류가 발생했습니다. 다시 시도해주세요.");
        }
      });
    }

    this.setState({ validated: true });
  }

  render() {
    const { validated, WILL_UPDATE } = this.state;

    return (
      <>
        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {!WILL_UPDATE ? '회원가입 (조회 아이디 신청)' : '조회 아이디 (학생정보) 수정'}
        </Navbar>
        <Container style={{ marginTop: '65px' }}>
          <AlertModal
            show={this.state.alertShow}
            onHide={this.alertClose}
            Title="스쿨라이프"
            Message={this.state.alertMessage}
            onClickOk={this.state.alertClickOk}
            onClickNo={this.state.alertClickNo}
            onClickYes={this.state.alertClickYes}
          />

          <div className="wrap-loading d-none">
            <img src={loader} alt="로딩 이미지" />
          </div>

          <div className='mb-3'>
            <img src={logoBi} alt="스쿨라이프" style={{ width: "90%", margin: '1rem' }} />
          </div>
          <Row>
            <Col>
              <ul className="pl-3">
                {!WILL_UPDATE ?
                  <>
                    <li>조회 아이디 신청은 유효 학생 1명당 1개의 아이디만 신청 가능합니다.</li>
                    <li>교직원 아이디 신청은 학교 관리자에게 문의해 주세요.</li>
                  </>
                  :
                  <li>새학기 학생정보를 입력하여 유효검사 한 후 이용 가능합니다.</li>
                }
                <li>학교관리자의 승인은 사정에 따라서 늦어질수도 있습니다. 관련 자세한 사항은 해당 학교로 문의해 주시기 바랍니다.</li>
                <li className='text-danger row pt-2'><Col className="col-auto"><img src={policeBi} alt="경찰청" style={{ width: "70px" }} /></Col><Col>"개인정보취급방침"에 의거 타인의 정보를 부정 열람하는 자는 관련 법에 의거하여 불이익을 당할 수 있습니다.</Col></li>
                <li className='text-danger'>만약, 타인의 정보를 도용하여 ID 가입을 하신 이용자분들은 지금 즉시 정보 열람 행위를 중단하시길 바랍니다.</li>
              </ul>
            </Col>
          </Row>
          <Form
            noValidate
            validated={validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            {!WILL_UPDATE ?
              <Row>
                <Form.Group
                  className="col-12"
                  controlId='ORGNZT_NM'>
                  <Form.Label>학교</Form.Label>
                  <InputGroup>
                    <Form.Control
                      className='text-center form-control-lg'
                      type='text'
                      aria-describedby='ORGNZT_NM'
                      value={this.state.ORGNZT_NM}
                      required
                      readOnly
                      onClick={() => this.fn_searchSchool()}
                      placeholder="학교를 조회 선택해 주세요"
                    />
                    <InputGroup.Append onClick={() => {
                      if (!this.state.USE_CHK)
                        this.fn_searchSchool();
                    }}>
                      <InputGroup.Text id='ORGNZT_NM'><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                    </InputGroup.Append>
                    <Form.Control.Feedback type='invalid'>
                      학교를 조회 선택해주세요
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Row> : null}
            <Row>
              <Form.Group
                className="col-12"
                controlId='HAKGWA'>
                <Form.Label>학과</Form.Label>
                <Form.Control
                  className='text-center form-control-lg'
                  as='select'
                  aria-describedby='HAKGWA'
                  name='HAKGWA'
                  readOnly={this.state.USE_CHK}
                >
                  {
                    this.state.hakgwaList === null ? null :
                      this.state.hakgwaList.map((data, idx) => {
                        return (
                          <option key={idx} value={data.HAKGWA}>{data.HAKGWA}</option>
                        );
                      })
                  }
                </Form.Control>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group
                className="col-4"
                controlId="GRADE">
                <Form.Label>학년</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control-lg"
                  aria-describedby="GRADE"
                  maxLength={1}
                  readOnly={this.state.USE_CHK}
                  required />
                <Form.Control.Feedback type="invalid">
                  학년을 입력해주세요.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="col-4"
                controlId="BAN">
                <Form.Label>반</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control-lg"
                  maxLength={2}
                  aria-describedby="BAN"
                  readOnly={this.state.USE_CHK}
                  required />
                <Form.Control.Feedback type="invalid">
                  반을 입력해주세요.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="col-4"
                controlId="BUN">
                <Form.Label>번호</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control-lg"
                  maxLength={2}
                  aria-describedby="BUN"
                  readOnly={this.state.USE_CHK}
                  required />
                <Form.Control.Feedback type="invalid">
                  번호를 입력해주세요.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group
                className="col-12"
                controlId="STD_NM">
                <Form.Label>이름</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    className="form-control-lg"
                    maxLength={50}
                    aria-describedby="STD_NM"
                    readOnly={this.state.USE_CHK}
                    required />
                  <InputGroup.Append onClick={() => {
                    this.fn_selectStdtIsExists();
                  }}>
                    <InputGroup.Text id='STD_NM' className='text-danger'><FontAwesomeIcon icon={faSearch} />&nbsp;유효검사{!WILL_UPDATE ? '' : '/정보수정'}</InputGroup.Text>
                  </InputGroup.Append>
                  <Form.Control.Feedback type="invalid">
                    이름을 입력해주세요.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>
            {!WILL_UPDATE ?
              <>
                <Row>
                  <Form.Group
                    className="col-12"
                    controlId="EMPLYR_ID">
                    <Form.Label>조회 아이디 (영문자로 시작하여 4~12자리)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        className="form-control-lg"
                        maxLength={12}
                        aria-describedby="EMPLYR_ID"
                        readOnly={this.state.EMPLYR_ID_CHK}
                        required />
                      <InputGroup.Append onClick={() => this.fn_selectIdIsExists()}>
                        <InputGroup.Text id='EMPLYR_ID' className='text-danger'><FontAwesomeIcon icon={faSearch} />&nbsp;중복검사</InputGroup.Text>
                      </InputGroup.Append>
                      <Form.Control.Feedback type="invalid">
                        조회 아이디를 입력해주세요.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group
                    className="col-12"
                    controlId="PASSWORD">
                    <Form.Label>비밀번호 (6~16자리, 영문/숫자/특수문자 조합)</Form.Label>
                    <Form.Control
                      type="password"
                      className="form-control-lg"
                      maxLength={16}
                      aria-describedby="PASSWORD"
                      required />
                    <Form.Control.Feedback type="invalid">
                      비밀번호를 입력해주세요.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group
                    className="col-12"
                    controlId="PASSWORD2">
                    <Form.Label>비밀번호 확인</Form.Label>
                    <Form.Control
                      type="password"
                      className="form-control-lg"
                      maxLength={16}
                      aria-describedby="PASSWORD2"
                      required />
                    <Form.Control.Feedback type="invalid">
                      비밀번호 확인을 입력해주세요.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Button type="submit" className="btn btn-lg btn-height btn-school-life col mt-3 mb-5">회원가입 (조회 아이디 신청)</Button>
              </> : null}
          </Form>
        </Container>

        {/* 학교목록 modal */}
        <Modal
          show={this.state.schoolAlertShow}
          onHide={() => this.alertClose('schoolAlertShow')}
          aria-labelledby='school-contained-modal-title-vcenter'
          animation={false}
          backdropClassName='show'
          centered
          className='customModal'
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title id='school-contained-modal-title-vcenter'>
              <span className='h5'>학교 검색 및 선택</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body id='schoolModalBody' style={{ padding: '0' }}>
            <InputGroup className='mb-3 pt-2 pl-3 pr-3'>
              <Form.Control
                className='form-control-lg'
                type='text'
                name='searchKeyword'
                id='searchKeyword'
                aria-describedby='searchKeyword'
                onChange={(e) => this.handleInputChange(e.target)}
                placeholder='찾고자 하는 학교명을 입력해 주세요'
              />
              <InputGroup.Prepend onClick={() => this.fn_searchSchool()}>
                <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control.Feedback type="invalid">
                서비스 이용 가능한 학교가 아닙니다.
              </Form.Control.Feedback>
            </InputGroup>
            <ListGroup variant='flush'>
              {
                this.state.schoolList === null ? null :
                  this.state.schoolList.map((data, idx) => {
                    return (
                      <ListGroup.Item key={idx} onClick={() => this.fn_select_school(data)}>
                        <span style={{ fontSize: '1.2rem', color: 'blue' }}>{data.ORGNZT_NM}</span><br />
                        <span style={{ float: 'right' }}><FontAwesomeIcon icon={faChevronRight} /></span>
                        {data.TEL}<br />
                        {data.ADDR}
                      </ListGroup.Item>
                    );
                  })
              }
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='link' onClick={() => { this.alertClose('schoolAlertShow') }}>닫기</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default JoinStdtCmp;